import React from 'react'
import classNames from 'classnames'
import { node, string } from 'prop-types'

import SmartLink from '../../SmartLink'
import ShrinkWrap from '../../ShrinkWrap'
import Icon from '../../Icon'
import Type from '../../Type'

import styles from './ProfileLink.module.scss'

const Link = ({ children, url, to, as, type, className }) => {
  const iconSizeMap = {
    globe: 20,
    email: 20
  }

  let cleanedUrl
  if (url) {
    if (url.startsWith('https://') || url.startsWith('http://')) {
      cleanedUrl = url
    } else {
      cleanedUrl = 'https://' + url
    }
  } else {
    cleanedUrl = ''
  }

  return (
    <SmartLink
      href={cleanedUrl}
      to={to}
      as={as}
      target="_blank"
      className={classNames(styles.Link, styles[type], className)}
    >
      <ShrinkWrap fullWidth>
        <ShrinkWrap.Item vAlign="middle" grow>
          <Type size={['body2', 'body4']}>{children}</Type>
        </ShrinkWrap.Item>

        <ShrinkWrap.Item vAlign="middle" shrink>
          <div className={styles.IconWrapper}>
            {type && <Icon width={iconSizeMap[type] || 12} type={type} />}
          </div>
        </ShrinkWrap.Item>
      </ShrinkWrap>
    </SmartLink>
  )
}

Link.propTypes = {
  children: node,
  url: string,
  to: string,
  as: string,
  type: string,
  className: string
}

export default Link
